import React from 'react';
import { GoogleLogout } from 'react-google-login';
import IntlMessages from '../../../util/IntlMessages';

class LogOut extends React.Component {
    render() {
        const type = localStorage.getItem("type")
        // const gStyle = {
        //     backgroundColor: 'rgb(255, 255, 255, 0)'
        // }
        if (type === 'g') {
            return (<GoogleLogout
                clientId="313348750424-slov7kepkavnakpq84o4ut1qbun1cs2b.apps.googleusercontent.com"
                buttonText=""
                className="google-logout-button-style"
                children={
                    <li className="list-inline-item mail-tour pointer pr-5 pl-5"><IntlMessages id="popup.logout" /></li>
                }
            />)
        } else if (type === 'f') {
            return (<li className="list-inline-item mail-tour pointer pr-5 pl-5"
                onClick={() => {
                    window.FB.logout()
                }}><IntlMessages id="popup.logout" /></li>)
        } else {
            return (<li className="list-inline-item mail-tour pointer pr-5 pl-5"><IntlMessages id="popup.logout" /></li>)
        }
    }
}
export default LogOut